import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Public web config (safe to expose in frontend)
const firebaseConfig = {
  apiKey: 'AIzaSyD54n3-GoEszcyV1QCv4izXYLA6SzNZvlE',
  authDomain: 'rc-poc-8b447.firebaseapp.com',
  projectId: 'rc-poc-8b447',
  storageBucket: 'rc-poc-8b447.firebasestorage.app',
  messagingSenderId: '614979555552',
  appId: '1:614979555552:web:e44b74c30e378bfd9f0085',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const googleProvider = new GoogleAuthProvider();
